<template>
    <section class="section register-form">
        <div class="ingreso">
            <div class="card py-4">
                <div class="card-header-title is-size-3 pt-2 has-text-primary">
                    <h3>Accede a tu cuenta</h3>
                </div>
                <div class="card-content">
                    <ValidationObserver
                        ref="observer"
                        v-slot="{ handleSubmit }"
                    >
                        <div class="field mb-6">
                            <label
                                class="label has-text-weight-bold"
                                for="email"
                            >
                                Email <span v-if="isAnalist" style="margin-left: 6px;">de superusuario</span>
                            </label>
                            <Input
                                rules="required|email|max:250"
                                type="email"
                                ref="email"
                                label="Email"
                                v-model="email"
                                placeholder="correo@ejemplo.cl"
                                autocomplete="username"
                                name="email"
                            />
                        </div>
                        <div v-if="isAnalist"  class="field mb-6">
                            <label
                                class="label has-text-weight-bold"
                                for="email"
                            >
                                Email del usuario a reemplazar
                            </label>
                            <Input
                                rules="required|max:250"
                                type="email"
                                ref="email"
                                label="Email"
                                v-model="email_to_login"
                                placeholder="correo1@ejemplo.cl"
                                autocomplete="username"
                                name="email_to_login"
                            />
                        </div>
                        <div class="field mb-6">
                            <label class="label has-text-weight-bold">
                                Clave
                            </label>
                            <Input
                                rules="required"
                                name="password"
                                type="password"
                                label="Contraseña"
                                ref="password"
                                placeholder="*****"
                                autocomplete="current-password"
                                v-model="password"
                                v-on:keyup.native.enter="
                                    handleSubmit(submitForm)
                                "
                                :is-password="true"
                            />
                        </div>
                        <div class="field mb-3 mt-3">
                            <button
                                class="button is-fullwidth is-primary"
                                :disabled="loading"
                                v-on:click.prevent="handleSubmit(submitForm)"
                            >
                                Iniciar Sesión
                            </button>
                        </div>
                    </ValidationObserver>
                    <p class="my-4 is-block has-text-left is-size-7">
                        ¿Olvidaste tu clave?
                        <a
                            class="ml-2 has-text-weight-semibold"
                            v-on:click.prevent="handleRecovery"
                        >
                            Recuperar clave
                        </a>
                    </p>
                </div>
            </div>
            <!-- <p class="my-6 is-size-7">
                ¿Aún no posees una cuenta?
                <a
                    class="ml-2 has-text-weight-semibold"
                    v-on:click.prevent="handleRegister"
                >
                    Crear una Cuenta
                </a>
            </p> -->
        </div>
    </section>
</template>

<script>
import Input from "@/components/inputs/Input";
import router from "@/router";
import { consoleHandlerError } from "@/utils/message";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { ValidationObserver } from "vee-validate";
import { mapActions } from "vuex";

export default {
    name: "FormLogin",
    components: {
        Input,
        ValidationObserver,
    },
    data: function() {
        return {
            email: "",
            email_to_login: "",
            password: "",
            loading: false,
        };
    },
    methods: {
        ...mapActions("userAuth", ["loginByUserInfo"]),
        handleRegister() {
            router.push("/register");
        },
        handleRecovery() {
            router.push("/recoverypassword");
        },
        submitForm() {
            this.loading = true;
            let username = this.email
            if(this.isAnalist){
                username = this.email+'&'+this.email_to_login
            }
            this.loginByUserInfo({
                username: username,
                password: this.password,
            })
                .then(() => {
                    new SegmentAnalytics().trackLogin();
                    router.push("/go-to-plan");
                })
                .catch((error) => {
                    this.loading = false;
                    consoleHandlerError({
                        error,
                        refFields: this.$refs,
                    });
                });
        },
    },
    props: {
        isAnalist: {
            type: Boolean,
            default: false
        }
    }
};
</script>
